module.exports = __webpack_public_path__ + "static/media/freeMarketAdvantage.07f7683a.svg";